import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Dumbbell, Loader2, ArrowLeftRight, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { txEquipment, txMuscle } from "@/lib/exerciseLabels";
import { DifficultyText } from "@/components/train/DifficultyPills";

function Thumb({ url, name }) {
  const [err, setErr] = useState(false);
  if (!url || err) {
    return <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-accent text-accent-foreground"><Dumbbell className="h-5 w-5" /></span>;
  }
  return <img src={url} alt={name} loading="lazy" onError={() => setErr(true)} className="h-12 w-12 shrink-0 rounded-xl border bg-white object-contain" />;
}

export function AlternativesList({ exId, lang, onSelect, mode = "view" }) {
  const id = lang === "id";
  const { data, isLoading } = useQuery({
    queryKey: ["ex-alternatives", exId],
    queryFn: async () => (await api.get(`/exercises/${exId}/alternatives`)).data,
    enabled: !!exId,
    staleTime: 300_000,
  });
  return (
    <div data-testid="alternatives-section">
      <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{id ? "Gerakan Pengganti" : "Alternatives"}</div>
      <p className="mt-1 text-xs text-muted-foreground">{id ? "Alat sedang dipakai? Coba gerakan untuk otot yang sama ini." : "Equipment taken? Try these moves for the same muscles."}</p>
      {isLoading ? (
        <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div>
      ) : (
        <div className="mt-3 space-y-2">
          {(data || []).map((a) => {
            const name = id ? a.name_id || a.name : a.name;
            return (
              <button key={a.id} type="button" onClick={() => onSelect(a)} data-testid={`alternative-${a.id}`}
                className="flex w-full items-center gap-3 rounded-xl border bg-card p-2.5 text-left transition-colors hover:border-primary/40 hover:bg-accent/40">
                <Thumb url={a.gif_url} name={name} />
                <span className="min-w-0 flex-1">
                  <span className="block truncate font-semibold">{name}</span>
                  <span className="flex flex-wrap items-center gap-x-1.5 text-xs text-muted-foreground">
                    {txMuscle((a.primary_muscles || [])[0], lang)} · {txEquipment(a.equipment, lang)} <DifficultyText level={a.difficulty} lang={lang} className="ml-1" />
                  </span>
                </span>
                {mode === "swap" ? (
                  <span className="inline-flex shrink-0 items-center gap-1 rounded-lg bg-primary px-2.5 py-1.5 text-xs font-semibold text-primary-foreground"><ArrowLeftRight className="h-3.5 w-3.5" /> {id ? "Ganti" : "Swap"}</span>
                ) : <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />}
              </button>
            );
          })}
          {data && !data.length && <p className="py-3 text-center text-sm text-muted-foreground">{id ? "Belum ada pengganti." : "No alternatives yet."}</p>}
        </div>
      )}
    </div>
  );
}
